import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { currentDateFormat } from "../utils";
import SaveButton from "../components/buttons/SaveButton";
import CancelButton from "../components/buttons/CancelButton";
import { DevTool } from "@hookform/devtools";
import { CREATE_AGENCY, GET_STATE_URI } from "../constant";
import ConfirmPassword from "../components/ConfirmPassword";
//import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from "../messageBox/customSweetAlert";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../redux/loaderAction";
import Loader from "../components/loader/Loader";

const CreateAgency = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [stateData, setStateData] = useState([]);
  const navigate = useNavigate();
  const inputRef = useRef("");
  var newNumber = "";
  var rand = Math.floor(Math.random() * (100 - 1 + 999) + 1);
  if (rand.toString().length === 2) {
    newNumber = "CT0" + rand;
  } else if (rand.toString().length === 3) {
    newNumber = "CT" + rand;
  } else {
    newNumber = "CT00" + rand;
  }

  const [randomNumber, setRandomNumber] = useState(newNumber);
  const { register, handleSubmit, control, formState, getValues, reset } =
    useForm({ defaultValues: { agency_id: randomNumber } });
  let { errors } = formState;
  const onSubmit = async (data) => {
    //console.log('error data:', errors);
    //return false;
    try {
      dispatch(setLoading(true));
      const response = await axios.post(CREATE_AGENCY, data);
      if (response.data.status === "200") {
        dispatch(setLoading(false));
        navigate("list");
        Swal.fire({
          title: "Success!",
          text: response.data.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        dispatch(setLoading(false));
        Swal.fire({
          title: "Error!",
          text: response.data.message,
          icon: "Error",
          confirmButtonText: "OK",
        });
      }
      //console.log('response:', response);
    } catch (error) {
      dispatch(setLoading(false));
      console.error("Error logging in:", error);
    }
  };

  useEffect(() => {
    // fetch user ID from API or storage
    const loadUser = async () => {
      const response_state = await axios.get(GET_STATE_URI);
      setStateData(response_state.data);
    };

    loadUser();
    //console.log(data);
  }, []);

  return (
    <>
      <div
        className="tab-pane fade active show"
        id="add-passenger"
        role="tabpanel"
        aria-labelledby="home-tab"
      >
        <section>
          <div className="d-flex justify-content-between form-container">
            <div>
              <h2 className="fs-5 font-weight-600"> Add Agency</h2>
            </div>
            <div>
              <span>{currentDateFormat(currentDate)}</span>
            </div>
          </div>
        </section>
        <section>
          <div className="bg-white  px-5 py-4">
            <div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-items">
                  <div>
                    <label className="require-field">Agency Name</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      id="preferred_name"
                      {...register("agency_name", {
                        required: {
                          value: true,
                          message: "Agency Name is required",
                        },
                      })}
                      onChange={(event) => {
                        const value = event.target.value;
                        event.target.value = value.replace(/[^A-Za-z\s]/g, "");
                      }}
                    />
                    <p className="errors">
                      {errors && errors.agency_name?.message}
                    </p>
                  </div>

                  <div>
                    <label className="require-field">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      id="address_line_one"
                      {...register("address_1", {
                        required: {
                          value: true,
                          message: "Address is required",
                        },
                      })}
                    />
                    <p className="errors">
                      {errors && errors.address_1?.message}
                    </p>
                  </div>

                  <div>
                    <label className="require-field">City</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      id="city"
                      {...register("city", {
                        required: {
                          value: true,
                          message: "City is required",
                        },
                      })}
                      onChange={(event) => {
                        const value = event.target.value;
                        event.target.value = value.replace(/[^A-Za-z\s]/g, "");
                      }}
                    />
                    <p className="errors">{errors && errors.city?.message}</p>
                  </div>
                  <div>
                    <label className="require-field">State</label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="state"
                      {...register("state")}
                    >
                      <option value="">Select</option>
                      {stateData.map((state, index) => (
                        <option key={index} value={state.state_id}>
                          {state.state_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="require-field">Zip</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      id="zip"
                      {...register("zip", {
                        required: {
                          value: true,
                          message: "Zip is required",
                        },
                      })}
                      onChange={(event) => {
                        const value = event.target.value;
                        event.target.value = value
                          .replace(/[^0-9]/g, "")
                          .substring(0, 5);
                      }}
                    />
                    <p className="errors">{errors && errors.zip?.message}</p>
                  </div>
                  <div className="form-item">
                    <label className="require-field">Email Address</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      id="email_address"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email",
                        },
                      })}
                    />
                    <p className="errors">{errors && errors.email?.message}</p>
                  </div>
                  <div className="row">
                    <div className="form-group col-sm-3 col-4 item">
                      <label>Company Id</label>
                      <input
                        type="text"
                        className="form-control"
                        ref={inputRef}
                        value={randomNumber}
                        id="agency_id"
                        {...register("agency_id", {
                          defaultValue: randomNumber,
                        })}
                        disabled={true}
                      />
                    </div>

                    <div class="form-check col-sm-3 col-8 item">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="is_active"
                        {...register("is_active")}
                      />
                      <label className="form-check-label" for="checkDefault">
                        Mark as Driver
                      </label>
                    </div>
                  </div>
                </div>
                <div className="my-4">
                  <p className="sub-title">User Details</p>
                  <div className="form-item">
                    <ConfirmPassword
                      register={register}
                      getValues={getValues}
                      errors={errors}
                    />
                  </div>
                </div>
                <div className="form-check col-sm-3 col-8 item">
                  <p className="sub-title ">Feature</p>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="enable_dhs"
                      {...register("enable_dhs")}
                    />
                    <label className="form-check-label" for="checkDefault">
                      Enable DHS
                    </label>
                  </div>
                </div>
                <div className="footer-content">
                  <SaveButton type="submit" buttonTitle={"ADD AGENCY"} />
                  <CancelButton cancelHandler={() => reset()} />
                </div>
              </form>
              <DevTool control={control} />
            </div>
          </div>
        </section>
      </div>
      <div> {loading && <Loader />}</div>
    </>
  );
};

export default CreateAgency;
